import React, { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import { Modal } from 'framework/ui/ui-builder';
import AddLinkRoundedIcon from '@mui/icons-material/AddLinkRounded';
import { CopyToClipboardButton } from 'framework/ui/clipboard';
import { Box, Typography } from '@mui/material';
import { useShowContext } from 'framework/show';
import {
  SOURCE_NAME,
  SOURCE_NAME_OPTIONS,
  SYCOM_UI_URL,
} from 'domain/recruiting/extension/candidateFromExtensionService';
import { FormFieldsData, EnumDropdown, TextInput } from 'framework/form';
import { Tooltip } from 'framework/ui/mui-builder';
import { VacancyDropdown } from 'domain/shared/newVacancy';

const GenerateLinkForSycomForm = ({ isUsingFromVacancyPage }: { isUsingFromVacancyPage: boolean }) => {
  const { data: showData } = useShowContext();
  const { alias } = showData.getData();

  const [vacancyAlias, setVacancyAlias] = useState<string>(alias);
  const [sourceName, setSourceName] = useState<string>();
  const [customSourceName, setCustomSourceName] = useState<string>();

  const [applyVacancyLink, setApplyVacancyLink] = useState<string>();

  const rabotaByGeneratedLink = isUsingFromVacancyPage
    ? `${SYCOM_UI_URL}/careers/vacancy/apply/?id=${vacancyAlias}&sourceName=${SOURCE_NAME_OPTIONS[SOURCE_NAME.RABOTA_BY]}`
    : '';
  const jjitGeneratedLink = isUsingFromVacancyPage
    ? `${SYCOM_UI_URL}/careers/vacancy/apply/?id=${vacancyAlias}&sourceName=${SOURCE_NAME_OPTIONS[SOURCE_NAME.JJIT]}`
    : '';
  const pracaPlGeneratedLink = isUsingFromVacancyPage
    ? `${SYCOM_UI_URL}/careers/vacancy/apply/?id=${vacancyAlias}&sourceName=${SOURCE_NAME_OPTIONS[SOURCE_NAME.PRACA_PL]}`
    : '';

  useEffect(() => {
    if (sourceName && sourceName !== SOURCE_NAME.OTHER && vacancyAlias) {
      setApplyVacancyLink(
        `${SYCOM_UI_URL}/careers/vacancy/apply/?id=${vacancyAlias}&sourceName=${SOURCE_NAME_OPTIONS[sourceName]}`,
      );
    } else if (customSourceName && vacancyAlias) {
      setApplyVacancyLink(`${SYCOM_UI_URL}/careers/vacancy/apply/?id=${vacancyAlias}&sourceName=${customSourceName}`);
    } else {
      setApplyVacancyLink('');
    }
  }, [sourceName, customSourceName, vacancyAlias]);

  const onVacancyAliasChangeCallback = (values: FormFieldsData) => {
    setVacancyAlias(values.vacancyAlias);
  };

  const onSourceNameChangeCallback = (values: FormFieldsData) => {
    setSourceName(values.sourceName);
  };

  const onCustomSourceNameChangeCallback = (values: FormFieldsData) => {
    setCustomSourceName(values.customSourceName);
  };

  return (
    <>
      {isUsingFromVacancyPage ? <Typography variant="h4">Generated links (passive sourcing)</Typography> : <></>}
      {isUsingFromVacancyPage ? (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: '10px',
            marginBottom: '20px',
          }}
        >
          <Box
            sx={{
              width: '33%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
          >
            <CopyToClipboardButton
              sx={{
                ml: 0.5,
                border: '0px',
                color: 'primary.main',
                fontSize: '15px',
                textDecoration: 'underline',
                padding: '0px',
              }}
              id="copyRabotaByVacancyLink"
              value={rabotaByGeneratedLink}
              isIcon={false}
              isCopyingFromModal
            >
              Rabota.by
            </CopyToClipboardButton>
            <CopyToClipboardButton
              sx={{ ml: 0.5, color: 'primary.main' }}
              id="copyRabotaByVacancyLink"
              value={rabotaByGeneratedLink}
              isContentCopyIcon
              isCopyingFromModal
            >
              Copy Rabota.by link
            </CopyToClipboardButton>
          </Box>
          <Box
            sx={{
              width: '33%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CopyToClipboardButton
              sx={{
                ml: 0.5,
                border: '0px',
                color: 'primary.main',
                fontSize: '15px',
                textDecoration: 'underline',
                padding: '0px',
              }}
              id="copyJJiTVacancyLink"
              value={jjitGeneratedLink}
              isIcon={false}
              isCopyingFromModal
            >
              JJIT
            </CopyToClipboardButton>
            <CopyToClipboardButton
              sx={{ ml: 0.5, color: 'primary.main' }}
              id="copyJJiTVacancyLink"
              value={jjitGeneratedLink}
              isContentCopyIcon
              isCopyingFromModal
            >
              Copy JJiT link
            </CopyToClipboardButton>
          </Box>
          <Box
            sx={{
              width: '33%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              paddingRight: '2%',
            }}
          >
            <CopyToClipboardButton
              sx={{
                ml: 0.5,
                border: '0px',
                color: 'primary.main',
                fontSize: '15px',
                textDecoration: 'underline',
                padding: '0px',
              }}
              id="copyPracaPlVacancyLink"
              value={pracaPlGeneratedLink}
              isIcon={false}
              isCopyingFromModal
            >
              Praca.pl
            </CopyToClipboardButton>
            <CopyToClipboardButton
              sx={{ ml: 0.5, color: 'primary.main' }}
              id="copyPracaPlVacancyLink"
              value={pracaPlGeneratedLink}
              isContentCopyIcon
              isCopyingFromModal
            >
              Copy Praca.pl link
            </CopyToClipboardButton>
          </Box>
        </Box>
      ) : (
        <></>
      )}
      <Box sx={{ marginTop: '10px' }}>
        <Typography variant="h4">Generate link</Typography>
      </Box>
      <Box sx={{ marginTop: '10px' }}>
        {!isUsingFromVacancyPage ? (
          <VacancyDropdown
            source="vacancyAlias"
            placeholder="Applied to vacancy"
            label=""
            onChangeCallback={onVacancyAliasChangeCallback}
            value={vacancyAlias}
          />
        ) : (
          <></>
        )}
        <EnumDropdown
          source="sourceName"
          placeholder="Source"
          options={SOURCE_NAME_OPTIONS}
          label=""
          onChangeCallback={onSourceNameChangeCallback}
          value={sourceName}
        />
        {sourceName && sourceName === SOURCE_NAME.OTHER ? (
          <TextInput
            source="customSourceName"
            label="Other source"
            value={customSourceName}
            onChangeCallback={onCustomSourceNameChangeCallback}
          />
        ) : (
          <></>
        )}
        <Box
          sx={{
            minHeight: '80px',
            width: '100%',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '10px',
            border: '1px solid',
            borderColor: 'border.default',
            borderRadius: '4px',
          }}
        >
          {applyVacancyLink ? (
            [
              <Box key="copyButton" sx={{ position: 'absolute', right: '5px', top: '5px' }}>
                <CopyToClipboardButton
                  sx={{ ml: 0.5, color: 'primary.main' }}
                  id="copyApplyVacancyLink"
                  value={applyVacancyLink}
                  isContentCopyIcon
                  isCopyingFromModal
                >
                  Copy the link
                </CopyToClipboardButton>
              </Box>,
              <Box key="copyText" sx={{ display: 'flex', alignItems: 'center', padding: '20px' }}>
                <CopyToClipboardButton
                  sx={{ ml: 0.5, border: '0px', color: 'primary.main' }}
                  id="copyApplyVacancyLink"
                  value={applyVacancyLink}
                  isIcon={false}
                  isCopyingFromModal
                >
                  {applyVacancyLink}
                </CopyToClipboardButton>
              </Box>,
            ]
          ) : (
            <Typography color="textSecondary" variant="body1">
              The link will be generated after selecting the vacancy and sourcing type
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

const GenerateLinkForSycomButton = ({ isUsingFromVacancyPage }: { isUsingFromVacancyPage: boolean }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Tooltip title="Generate">
        <div>
          <IconButton
            onClick={(e: React.MouseEvent<HTMLElement>) => {
              setModalOpen(true);
              (e.target as HTMLElement).blur();
            }}
          >
            <AddLinkRoundedIcon color="primary" fontSize="medium" />
          </IconButton>
        </div>
      </Tooltip>
      <Modal backdrop="static" isOpen={modalOpen} title="Link generation" onToggle={closeModal}>
        <GenerateLinkForSycomForm isUsingFromVacancyPage={isUsingFromVacancyPage} />
      </Modal>
    </>
  );
};

export default GenerateLinkForSycomButton;
